export const saveFormValues = (key, values) => {
  // Check if window is defined (to determine if code is running on the server or client)
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(values));
  }
};

export const loadFormValues = (key) => {
  // Check if window is defined (to determine if code is running on the server or client)
  if (typeof window !== 'undefined') {
    const storedValues = localStorage.getItem(key);
    return storedValues ? JSON.parse(storedValues) : null;
  }

  return null;
};

export const consultationOriginalPrice = {
  USD: '599',
  EUR: '599',
  JPY: '49999',
  INR: '7,999',
  GBP: '599',
  POUND: '599'
};

export const consultationSellingPrices = {
  USD: '299',
  EUR: '299',
  JPY: '24999',
  INR: '3,999',
  GBP: '299',
  POUND: '299',
};

export const consultationGstPrices = {
  USD: '299',
  EUR: '299',
  JPY: '24999',
  INR: '4,718',
  GBP: '299',
  POUND: '299',
};

export const consultationGstAmount = {
  USD: '0',
  EUR: '0',
  JPY: '0',
  INR: '719',
  GBP: '0',
  POUND: '0',
};

export const consultationSaving = {
  USD: '300',
  EUR: '300',
  JPY: '25000',
  INR: '4,000',
  GBP: '300',
  POUND: '300',
};

export const consultationDifference = {
  USD: '$ 100',
  EUR: '€ 100',
  JPY: '¥ 10000',
  INR: 'Rs. 2,000',
  GBP: '£ 100',
  POUND: '£ 100',
};

export const sellingPrices = {
  USD: '199',
  EUR: '199',
  JPY: '19999',
  INR: '1,999',
  GBP: '199',
  POUND: '199',
};

export const sellingGstPrices = {
  USD: '199',
  EUR: '199',
  JPY: '19999',
  INR: '2,359',
  GBP: '199',
  POUND: '199',
};

export const sellingGstAmount = {
  USD: '0',
  EUR: '0',
  JPY: '0',
  INR: '360',
  GBP: '0',
  POUND: '0',
};

export const originalPrices = {
  USD: '399',
  EUR: '399',
  JPY: '39999',
  INR: '3,999',
  GBP: '199',
  POUND: '399',
};

export const savingPrices = {
  USD: '200',
  EUR: '200',
  JPY: '20000',
  INR: '2,000',
  GBP: '200',
  POUND: '200',
};


export const currencySign = {
  USD: '$',
  EUR: '€',
  JPY: '¥',
  INR: 'Rs.',
  GBP: '£',
  POUND: '£',
};

export const stagesMainHash = {
  0: 'department',
  1: 'name',
  2: 'phone',
};

export const stagesCostHash = {
  0: 'name',
  1: 'phone',
  2: 'email',
};

export const stagesTreatmentPatientHash = {
  0: 'department',
  1: 'treatment',
  2: 'gender',
  3: 'age',
  4: 'country',
  5: 'preferred-country',
  6: 'budget',
  7: 'summary',
  8: 'documents',
  9: 'matched-hospitals',
  10: 'booking-payment',
  11: 'success'
};

export const stagesPatientHash = {
  0: 'gender',
  1: 'age',
  2: 'diagnosis',
  3: 'symptoms',
  4: 'treatments',
  5: 'summary',
  6: 'email',
  7: 'documents',
  8: 'match-doctors',
  9: 'consultation-payment',
  10: 'success'
};

export const stagesOpinionHash = {
  0: 'gender',
  1: 'age',
  2: 'diagnosis',
  3: 'symptoms',
  4: 'treatments',
  5: 'summary',
  6: 'queries',
  7: 'email',
  8: 'documents',
  9: 'book-opinion',
  10: 'opinion-payment',
  11: 'success'
};

export const progressPercent = {
  department: 5,
  name: 15,
  phone: 20,
  gender: 35,
  age: 40,
  diagnosis: 45,
  symptoms: 55,
  treatments: 65,
  summary: 75,
  queries: 78,
  email: 82,
  documents: 86,
  'match-doctors': 90,
  'book-opinion': 90,
  'opinion-payment': 95,
  'consultation-payment': 95,
  success: 100
};

export const costProgressPercent = {
  name: 7,
  phone: 14,
  email: 21,
  department: 28,
  treatment: 35,
  gender: 42,
  age: 49,
  country: 56,
  'preferred-country': 60,
  budget: 63,
  summary: 70,
  documents: 77,
  'matched-hospitals': 90,
  'booking-payment': 95,
  success: 100
};
